import { FC } from "react";

export const JsonDebugger: FC<{ value: any }> = ({ value }) => {
	return <pre>{JSON.stringify(value, null, 2)}</pre>;
};
